module.exports = __webpack_public_path__ + "img/15.e91eb8cc.jpg";